// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b5c3260a","119":"64f4ca63","186":"5be2ccda","272":"f9af653e","372":"78b010c2","443":"0287832a","738":"9ff5ff1c","841":"692c8bca","851":"fd885b61","856":"78431ce6","965":"cb18cc9d"}[chunkId] + ".chunk.js";
};